module.exports = __webpack_public_path__ + "static/media/22ESCWA17.44c5a8f4.jpg";